import React from "react";
import {
  ChakraProvider,
  createSystem,
  defaultConfig,
  Theme,
} from "@chakra-ui/react";

const system = createSystem(defaultConfig, {
  theme: {
    tokens: {
      colors: {
        primary: { value: "#00e5ff" },
        "primary.light": { value: "#62efff" },
        "primary.dark": { value: "#00b2cc" },
        secondary: { value: "#ff4081" },
        accent: { value: "#00e5ff" },
      },
      radii: {
        input: { value: "8px" },
        card: { value: "12px" },
      },
    },
    semanticTokens: {
      colors: {
        "bg.default": { value: { base: "#0a0a0a", _dark: "#0a0a0a" } },
        "bg.panel": { value: { base: "#1a1a1a", _dark: "#1a1a1a" } },
        "fg": { value: { base: "#ffffff", _dark: "#ffffff" } },
        "fg.muted": { value: { base: "rgba(255,255,255,0.8)", _dark: "rgba(255,255,255,0.8)" } },
        "border": { value: { base: "rgba(0,229,255,0.2)", _dark: "rgba(0,229,255,0.2)" } },
      },
    },
  },
  globalCss: {
    html: { bg: "#0a0a0a" },
    body: { bg: "#0a0a0a", color: "#ffffff", minHeight: "100%" },
    "#root": { minHeight: "100%", bg: "#0a0a0a" },
  },
});

export function ChakraUIProvider({ children }) {
  return (
    <ChakraProvider value={system}>
      <Theme appearance="dark" hasBackground>
        {children}
      </Theme>
    </ChakraProvider>
  );
}
